export default class Rates {
    get_household_occ_weight(houseOcc) {
		var house_occ_weight;
		switch (houseOcc) {
			case '1A':
				house_occ_weight = 0.721501129;
				break;
			case '2A':
				house_occ_weight = 1.206264108;
				break;
			case '1A1C':
				house_occ_weight = 0.898137698;
				break;
			case '1A2C':
				house_occ_weight = 0.928611738;
				break;
			case '2A1C':
				house_occ_weight = 1.288092551;
				break;
			case '2A2C':
				house_occ_weight = 1.425225734;
				break;
			case '2A3C':
				house_occ_weight = 1.574492099;
				break;
			case '3ANC':
				house_occ_weight = 1.427200903;
				break;
			case '3AWC':
				house_occ_weight = 1.474322799;
				break;
		}
		return house_occ_weight;
	}

    // Calc Region Expenditure
	get_region_expenditure(region) {
		var region_expenditure;
		switch (region) {
			case 'NE':
				region_expenditure = 991.47;
				break;
			case 'NW':
				region_expenditure = 1164.39;
				break;
			case 'YH':
				region_expenditure = 1112.47;
				break;
			case 'EM':
				region_expenditure = 1152.20;
				break;
			case 'WM':
				region_expenditure = 1139.11;
				break;
			case 'EE':
				region_expenditure = 1230.76;
				break;
			case 'LO':
				region_expenditure = 1181.10;
				break;
			case 'SE':
				region_expenditure = 1315.64;
				break;
			case 'SW':
				region_expenditure = 1214.96;
				break;
			case 'WA':
				region_expenditure = 1103.89;
				break;
		}
		return region_expenditure.toFixed(2);
	}

    get_region_counciltax(region) {
		var region_counciltax;
		switch (region) {
			case 'NE':
				region_counciltax = 192.90;
				break;
			case 'NW':
				region_counciltax = 186.61;
				break;
			case 'YH':
				region_counciltax = 180.25;
				break;
			case 'EM':
				region_counciltax = 187.90;
				break;
			case 'WM':
				region_counciltax = 178.69;
				break;
			case 'EE':
				region_counciltax = 181.97;
				break;
			case 'LO':
				region_counciltax = 157.87;
				break;
			case 'SE':
				region_counciltax = 187.22;
				break;
			case 'SW':
				region_counciltax = 191.58;
				break;
			case 'WA':
				region_counciltax = 166.46;
				break;
		}
		return region_counciltax.toFixed(2);
	}

	calc_monthly_net_income(ann_gross_income) {
        // Calc Applicant Tax Allowance
		var taxable_income = this.calc_taxable_income(ann_gross_income);
		// Calc basic tax
		var basic_tax = this.calc_basic_tax(taxable_income);
		// Calc higher tax
		var higher_tax = this.calc_higher_tax(taxable_income);
		// Calc Add higher tax
		var add_higher_tax = this.calc_add_higher_tax(taxable_income);
		// Total App Tax
		var total_tax = (parseFloat(basic_tax) + parseFloat(higher_tax) + parseFloat(add_higher_tax));

		// Calc Applicant NI
		var basic_ni = this.calc_basic_ni(ann_gross_income);
		// Calc higher NI
		var higher_ni = this.calc_higher_ni(ann_gross_income);
		// Total Applicant NI
		var total_ni = (parseFloat(basic_ni) + parseFloat(higher_ni));

		// Calc and send back Net Monthly Income
		var monthly_net_income = ((ann_gross_income - (total_tax + total_ni)) / 12);
		
		return parseFloat(monthly_net_income.toFixed(2));
    }

	calc_taxable_income(ann_gross_income) {
		// As per 2020/21 tax yr
		var std_tax_free_allowance = 12500;

		var tax_allowance;
		var taxable_income;

		if (ann_gross_income < 100000) {
			tax_allowance = std_tax_free_allowance;
		} else if (ann_gross_income < 125000) {
			tax_allowance = std_tax_free_allowance - ((ann_gross_income - 100000) / 2);
		} else {
			tax_allowance = 0;
		}

		// Work out taxable income
		if (ann_gross_income > std_tax_free_allowance) {
			taxable_income = (ann_gross_income - tax_allowance);
		} else {
			taxable_income = 0;
		}

		// Rtn taxable income
		return taxable_income;
	}

	// Calc Basic Rate Tax
	calc_basic_tax(taxable_income) {
		//Set the Band Limits for 20% band
		var basic_rate = 0.20;
		//var basic_rate_lower = 0;
		var basic_rate_upper = 37700;

		// The amount of basic rate tax to pay
		var basic_rate_tax;

		if (taxable_income < basic_rate_upper) {
			// Taxable income less than the Basic Upper Limit
			basic_rate_tax = (taxable_income * basic_rate);
		} else {
			// Taxable income is more than the basic upper limit
			basic_rate_tax = (basic_rate_upper * basic_rate);
		}
		return basic_rate_tax.toFixed(2);
	}

	// Calc Higher Rate Tax
	calc_higher_tax(taxable_income) {
		//Set the Band Limits for 40% band
		var higher_rate = 0.40;
		var higher_rate_lower = 37701;
		var higher_rate_upper = 150000;

		// The amount of higher rate tax to pay
		var higher_rate_tax;

		if (taxable_income > higher_rate_lower) {
			// we now need to work out how much higher rate tax to pay
			if (taxable_income > higher_rate_upper) {
				// income higher than higher upper limit
				higher_rate_tax = ((higher_rate_upper - higher_rate_lower) * higher_rate);
			} else {
				// income is somewhere between lower and upper higher band
				// so calc how much over the lower limit
				higher_rate_tax = ((taxable_income - higher_rate_lower) * higher_rate);
			}
		} else {
			// This income is not eligible for higher rate
			higher_rate_tax = 0;
		}
		return higher_rate_tax.toFixed(2);
	}

	// Calc Additional Higher Rate Tax
	calc_add_higher_tax(taxable_income) {
		//Set the Band Limits for 45% band
		var add_higher_rate = 0.45;
		var add_higher_rate_lower = 150001;

		// The amount of additional higher rate tax to pay
		var add_higher_rate_tax;

		if (taxable_income > (add_higher_rate_lower - 1)) { // £150,000
			// we now need to work out how much additional higher rate tax to pay
			// so calc how much over the additional higher rate lower limit
			add_higher_rate_tax = ((taxable_income - add_higher_rate_lower) * add_higher_rate);
		} else {
			// This income is not eligible for additional higher rate
			add_higher_rate_tax = 0;
		}

		return add_higher_rate_tax.toFixed(2);
	}// end func

    // Calc Basic National Insurance
	calc_basic_ni(ann_gross_income) {
		//Set band limits for 12% NI
		var basic_ni_rate = 0.1325;
		var basic_ni_lower = 12570;
		var basic_ni_upper = 50270;

		// The amount of basic NI to pay
		var basic_ni;

		if (ann_gross_income > basic_ni_upper) {
			// gross income is higher than basic ni upper
			// so its the differece * 12%
			basic_ni = ((basic_ni_upper - basic_ni_lower) * basic_ni_rate);
		} else if (ann_gross_income > (basic_ni_lower - 1)) {
			// gross income is less than upper limit and more than lower of previous band hence -1
			basic_ni = (ann_gross_income - (basic_ni_lower - 1)) * basic_ni_rate;
		} else {
			basic_ni = 0;
		}

		return basic_ni.toFixed(2);

	}// end func

	// Calc Higher National Insurance
	calc_higher_ni(ann_gross_income) {
		//Set band limits for Upper 2% NI
		var higher_ni_rate = 0.0325;
		var higher_ni_lower = 50271;

		// The amount of basic NI to pay
		var higher_ni;

		if (ann_gross_income > (higher_ni_lower - 1)) {
			// gross income is higher than basic ni upper £50,024 hence the - 1
			// so calc how much over * 2%
			higher_ni = (ann_gross_income - (higher_ni_lower - 1)) * higher_ni_rate;
		} else {
			higher_ni = 0;
		}

		return higher_ni.toFixed(2);

	}
}
